import './styles.scss';

const NotFound = () => {
  return (
    <>
      <div className="notFound">
        <div className="notFound-404">
          <h3>Oops! Página não encontrada!</h3>
          <h1>
            <span>4</span>
            <span>0</span>
            <span>4</span>
          </h1>
        </div>
        <h2>Desculpe, a página que você procura não existe :(</h2>
      </div>
    </>
  );
};

export default NotFound;
